module.exports = __webpack_public_path__ + "static/media/how-it-works.5e3b0386.png";